import React from "react";

import { FieldSet, SubmitButton } from "./submitButtom.style";

const SubmitButtonComponent: React.FC = () => {
  return (
    <FieldSet>
      <SubmitButton type="submit" id="contact-submit">
        Submit
      </SubmitButton>
    </FieldSet>
  );
};

export default SubmitButtonComponent;
